import React from 'react';

export const ReadMoreIcon = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.888889 8C0.644444 8 0.435185 7.91296 0.261111 7.73889C0.087037 7.56482 0 7.35556 0 7.11111V0.888889C0 0.644444 0.087037 0.435185 0.261111 0.261111C0.435185 0.087037 0.644444 0 0.888889 0H4V0.888889H0.888889V7.11111H7.11111V4H8V7.11111C8 7.35556 7.91296 7.56482 7.73889 7.73889C7.56482 7.91296 7.35556 8 7.11111 8H0.888889ZM2.97778 5.64444L2.35556 5.02222L6.48889 0.888889H4.88889V0H8V3.11111H7.11111V1.51111L2.97778 5.64444Z"
        fill="#D0AB71"
      />
    </svg>
  );
};
